import { connect } from 'react-redux';
import { fetchExpiredQuote } from '../../../../redux/modules/transaction';
import TransactionError from './TransactionError';

export default connect(null, { fetchExpiredQuote })(TransactionError);
